/**
 * Rendering mode of the progress bar. Single source of truth for which visual
 * treatment the component applies.
 *
 * - `determinate`: bar width follows `value` (0-100). Status recoloring active.
 * - `indeterminate`: continuous animation for unknown-duration operations. No status.
 * - `unlimited`: 100%-width dotted texture signalling an unmetered resource. No status.
 *
 * @since 8.3.0 Initial implementation.
 */
export const ProgressLinearType = {
    DETERMINATE: 'determinate',
    INDETERMINATE: 'indeterminate',
    UNLIMITED: 'unlimited',
};
/**
 * Status reached by the progress bar based on its current `value` and the
 * active thresholds. Maps to a CSS variable that recolors the fill. Only
 * computed while {@link ProgressLinearType} is `determinate`.
 *
 * @since 8.3.0 Initial implementation.
 */
export const ProgressLinearStatus = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
};
/**
 * Default thresholds applied when the consumer does not pass its own.
 *
 * - `< 70`: success
 * - `>= 70` and `< 90`: warning
 * - `>= 90`: error
 *
 * @since 8.3.0 Initial implementation.
 */
export const DEFAULT_PROGRESS_LINEAR_THRESHOLDS = {
    warning: 70,
    error: 90,
};
